import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/API";

// Holds the in-flight request so concurrent dispatches share one HTTP call
let profileRequestPromise = null;

export const AccountProfile = createAsyncThunk("AccountProfile", async () => {
    if (!profileRequestPromise) {
        profileRequestPromise = axiosInstance.get("/user_profile/").finally(() => {
            profileRequestPromise = null;
        });
    }
    try {
        const response = await profileRequestPromise;
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

export const AccountProfiledit = createAsyncThunk(
    "AccountProfiledit",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.patch(`/editprofile/`, data, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || {});
        }
    }
);

export const AccountProfileNameEdit = createAsyncThunk(
    "AccountProfileNameEdit",
    async (data) => {
        const response = await axiosInstance.patch(`edit_names/`, data);
        try {
            const result = response.data;
            return result;
        } catch (error) {
            return error;
        }
    }
);

export const AccountProfilePosts = createAsyncThunk(
    "AccountProfilePosts",
    async ({ id, nextUrl, isLoadMore = false }) => {
        try {
            let response;
            if (nextUrl) {
                // Extract path from full URL
                const url = new URL(nextUrl);
                const pathAndQuery = url.pathname + url.search;
                const relativePath = pathAndQuery.replace('/api', '');
                response = await axiosInstance.get(relativePath);
            } else {
                response = await axiosInstance.get(`/post/profile/${id}/public-posts/`);
            }
            return { data: response.data, isLoadMore };
        } catch (error) {
            throw error;
        }
    }
);

export const otherUserAccountPosts = createAsyncThunk(
    "otherUserAccountPosts",
    async ({ id, nextUrl, isLoadMore = false }) => {
        try {
            let response;
            if (nextUrl) {
                // Extract path from full URL
                const url = new URL(nextUrl);
                const pathAndQuery = url.pathname + url.search;
                const relativePath = pathAndQuery.replace('/api', '');
                response = await axiosInstance.get(relativePath);
            } else {
                response = await axiosInstance.get(`/post/profile/${id}/public-posts/`);
            }
            return { data: response.data, isLoadMore };
        } catch (error) {
            throw error;
        }
    }
);
export const SearchAccountProfilePublicPosts = createAsyncThunk(
    "SearchAccountProfilePublicPosts",
    async ({ userId, search }) => {
        const response = await axiosInstance.get(`/post/public-post-profile-search/${userId}/?search=${search}`);
        try {
            const result = response.data;
            return result;
        } catch (error) {
            return error;
        }
    }
);

export const AccountProfilePostDelete = createAsyncThunk(
    "AccountProfilePostDelete",
    async (id) => {
        const response = await axiosInstance.delete(`post/delete/${id}/`);
        try {
            const result = response.data;
            return result;
        } catch (error) {
            return error;
        }
    }
);

export const UserAccountFollowerlist = createAsyncThunk(
    "UserAccountFollowerlist",
    async (arg = {}) => {
        const { page = 1, isLoadMore = false } = typeof arg === 'object' ? arg : {};
        try {
            const response = await axiosInstance.get(`/followers_list/?page=${page}`);
            return { data: response.data, isLoadMore };
        } catch (error) {
            throw error;
        }
    }
);

export const UserAccountFollowinglist = createAsyncThunk(
    "UserAccountFollowinglist",
    async (arg = {}) => {
        const { page = 1, isLoadMore = false } = typeof arg === 'object' ? arg : {};
        try {
            const response = await axiosInstance.get(`/following_list/?page=${page}`);
            return { data: response.data, isLoadMore };
        } catch (error) {
            throw error;
        }
    }
);

export const searchOtherUserFollowersList = createAsyncThunk(
    "searchOtherUserFollowersList",
    async ({ userId, q }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/followers/${userId}/search/`, { params: { q } });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || {});
        }
    }
);

export const searchotherUserFollowingList = createAsyncThunk(
    "searchotherUserFollowingList",
    async ({ userId, q }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/following/${userId}/search/`, { params: { q } });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || {});
        }
    }
);

export const searchMyFollowersList = createAsyncThunk(
    "searchMyFollowersList",
    async ({ q }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/followers/search/`, { params: { q } });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || {});
        }
    }
);

export const searchMyFollowingList = createAsyncThunk(
    "searchMyFollowingList",
    async ({ q }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/following/search/`, { params: { q } });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || {});
        }
    }
);

export const UserAccountFollow = createAsyncThunk(
    "UserAccountFollow",
    async (id) => {
        const response = await axiosInstance.post(`/follow/${id}/`);
        try {
            const result = response.data;
            return result;
        } catch (error) {
            return error;
        }
    }
);

export const OtherUserProfile = createAsyncThunk(
    "OtherUserProfile",
    async (id) => {
        const response = await axiosInstance.get(`/another-user/${id}/`);
        try {
            const result = response.data;
            return result;
        } catch (error) {
            return error;
        }
    }
);

export const otherUserFollowersList = createAsyncThunk(
    "otherUserFollowersList",
    async (arg) => {
        const { id, page = 1, isLoadMore = false } = typeof arg === 'object' ? arg : { id: arg };
        try {
            const response = await axiosInstance.get(`/followers/${id}/?page=${page}`);
            return { data: response.data, isLoadMore };
        } catch (error) {
            throw error;
        }
    }
);

export const otherUserFollowingList = createAsyncThunk(
    "otherUserFollowingList",
    async (arg) => {
        const { id, page = 1, isLoadMore = false } = typeof arg === 'object' ? arg : { id: arg };
        try {
            const response = await axiosInstance.get(`/following/${id}/?page=${page}`);
            return { data: response.data, isLoadMore };
        } catch (error) {
            throw error;
        }
    }
);

export const getPrivateVideos = createAsyncThunk(
    "getPrivateVideos",
    async ({ id, nextUrl, isLoadMore = false } = {}) => {
        try {
            let response;
            if (nextUrl) {
                const url = new URL(nextUrl);
                const pathAndQuery = url.pathname + url.search;
                const relativePath = pathAndQuery.replace('/api', '');
                response = await axiosInstance.get(relativePath);
            } else {
                response = await axiosInstance.get(`/post/profile/${id}/private-posts/`);
            }
            return { data: response.data, isLoadMore };
        } catch (error) {
            throw error;
        }
    }
);
export const removeFollowers = createAsyncThunk(
    "removeFollowers",
    async (id) => {
        const response = await axiosInstance.delete(`remove_follower/${id}/`);
        try {
            const result = response.data;
            return result;
        } catch (error) {
            return error;
        }
    }
);
export const accountBlockUser = createAsyncThunk(
    "accountBlockUser", async (id) => {
        const response = await axiosInstance.post(`/block/${id}/`, {});
        try {
            const result = response.data;
            return result;
        } catch (error) {
            return error;
        }
    }
);

export const accountUnBlockUser = createAsyncThunk(
    "accountUnBlockUser", async (id) => {
        const response = await axiosInstance.post(`/unblock/${id}/`, {});
        try {
            const result = response.data;
            return result;
        } catch (error) {
            return error;
        }
    }
);

export const otheruserAccountReport = createAsyncThunk(
    "otheruserAccountReport",
    async ({ data }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`/report-user/`, data);
            return response.data; // Return only the data, not the whole response
        } catch (error) {
            // Return the error response data for use in the rejected action
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ non_field_errors: ["Something went wrong."] });
        }
    }
);

export const shareUserAccount = createAsyncThunk("shareUserAccount", async (data) => {
    try {
        const response = await axiosInstance.post(`/messages/share-user-account/`, data);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
});

export const AccountProfileSlice = createSlice({
    name: "AccountProfile",
    initialState: {
        User_profile: {},
        User_posts: [],
        otherUser_posts: [],
        User_followersList: [],
        following_count: 0,
        followers_count: 0,
        User_followingList: [],
        otherUser_profile: {},
        private_Videos: [],
        privateVideosNextPage: null,
        privateVideosHasMore: false,
        privateVideosLoadingMore: false,
        loading: false,
        loadingMore: false,
        error: null,
        posts_count: 0,
        otherUser_posts_count: 0,
        nextPage: null,
        previousPage: null,
        hasMore: false,
        otherFollowersHasMore: false,
        otherFollowingHasMore: false,
        loadingMoreConnections: false,
        myFollowersHasMore: false,
        myFollowingHasMore: false,
        loadingMoreMyConnections: false,
        mySearchedFollowersList: [],
        mySearchedFollowingList: [],
        searchingMyFollowers: false,
        searchingMyFollowing: false,
        otherSearchedFollowersList: [],
        otherSearchedFollowingList: [],
        searchingOtherFollowers: false,
        searchingOtherFollowing: false,
    },
    reducers: {
        clearAccountProfile: (state) => {
            state.User_profile = {};
            state.User_posts = [];
            state.User_followersList = [];
            state.User_followingList = [];
            state.following_count = 0;
            state.followers_count = 0;
            state.otherUser_profile = [];
            state.private_Videos = [];
            state.privateVideosNextPage = null;
            state.privateVideosHasMore = false;
            state.privateVideosLoadingMore = false;
            state.loading = false;
            state.loadingMore = false;
            state.error = null;
            state.posts_count = 0;
            state.nextPage = null;
            state.previousPage = null;
            state.hasMore = false;
            state.otherFollowersHasMore = false;
            state.otherFollowingHasMore = false;
            state.loadingMoreConnections = false;
            state.myFollowersHasMore = false;
            state.myFollowingHasMore = false;
            state.loadingMoreMyConnections = false;
            state.mySearchedFollowersList = [];
            state.mySearchedFollowingList = [];
            state.searchingMyFollowers = false;
            state.searchingMyFollowing = false;
            state.otherSearchedFollowersList = [];
            state.otherSearchedFollowingList = [];
            state.searchingOtherFollowers = false;
            state.searchingOtherFollowing = false;
        },

        postCreatedUpdateState: (state, action) => {
            const newPost = action.payload;
            state.User_posts = [newPost, ...state.User_posts];
            state.posts_count += 1;
        },
        removePostFromList: (state, action) => {
            state.User_posts = state.User_posts.filter(post => post.id !== action.payload);
            state.posts_count = state.posts_count > 0 ? state.posts_count - 1 : 0;
        },
        updatePostLikeStatus: (state, action) => {
            const { postId, isLiked } = action.payload;
            const postIndex = state.User_posts.findIndex(post => post.id === postId);
            if (postIndex !== -1) {
                const post = state.User_posts[postIndex];
                post.userliked = isLiked;
                post.likes_count += isLiked ? 1 : -1;
            }
        },

        followUpdate: (state, action) => {
            const { isFollowing } = action.payload;
            if (state.otherUser_profile) {
                state.otherUser_profile = {
                    ...state.otherUser_profile,
                    is_following: isFollowing,
                };
            }
        },
        resetLoadingMore: (state) => {
            state.loadingMore = false;
        },
        removePrivateVideoFromList: (state, action) => {
            state.private_Videos = state.private_Videos.filter(v => v.id !== action.payload);
        },
    },
    extraReducers: (builder) => {
        // AccountProfile action promises
        builder.addCase(AccountProfile.pending, (state) => {
            state.error = null;
        });
        builder.addCase(AccountProfile.fulfilled, (state, action) => {
            state.User_profile = action.payload;
            state.posts_count = action.payload.post_count || 0;
        });
        builder.addCase(AccountProfile.rejected, (state, action) => {
            state.error = action.payload;
        });

        // AccountProfileNameEdit action promises
        builder.addCase(AccountProfileNameEdit.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(AccountProfileNameEdit.fulfilled, (state, action) => {
            state.loading = false;
        });
        builder.addCase(AccountProfileNameEdit.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // AccountProfilePosts action promises
        builder.addCase(AccountProfilePosts.pending, (state, action) => {
            if (action.meta.arg.isLoadMore) {
                state.loadingMore = true;
            } else {
                state.loading = true;
                state.loadingMore = false; // Reset loadingMore on initial load
                state.User_posts = []; // Clear existing posts when not loading more
            }
        });
        builder.addCase(AccountProfilePosts.fulfilled, (state, action) => {
            const { data, isLoadMore } = action.payload;

            if (isLoadMore) {
                state.loadingMore = false;
                state.User_posts = [...state.User_posts, ...(data.results?.posts || [])];
            } else {
                state.loading = false;
                state.User_posts = data.results?.posts || [];
            }

            // state.posts_count = data.count || 0;
            state.nextPage = data.next;
            state.previousPage = data.previous;
            state.hasMore = !!data.next;
        });
        builder.addCase(AccountProfilePosts.rejected, (state, action) => {
            if (action.meta.arg.isLoadMore) {
                state.loadingMore = false;
            } else {
                state.loading = false;
            }
            state.error = action.payload;
        });

        /// otherUserAccountPosts action promises
        builder.addCase(otherUserAccountPosts.pending, (state, action) => {
            if (action.meta.arg.isLoadMore) {
                state.loadingMore = true;
            } else {
                state.loading = true;
                state.loadingMore = false; // Reset loadingMore on initial load
            }
        });
        builder.addCase(otherUserAccountPosts.fulfilled, (state, action) => {
            const { data, isLoadMore } = action.payload;
            if (isLoadMore) {
                state.loadingMore = false;
                state.otherUser_posts = [...state.otherUser_posts, ...(data.results?.posts || [])];
            } else {
                state.loading = false;
                state.otherUser_posts = data.results?.posts || [];
            }
            // state.posts_count = data.count || 0;
            state.nextPage = data.next;
            state.previousPage = data.previous;
            state.hasMore = !!data.next;
        });
        builder.addCase(otherUserAccountPosts.rejected, (state, action) => {
            if (action.meta.arg.isLoadMore) {
                state.loadingMore = false;
            } else {
                state.loading = false;
            }
            state.error = action.payload;
        });


        /// AccountProfilePostDelete action promises
        builder.addCase(AccountProfilePostDelete.pending, (state) => {
            // state.loading = true;
        });
        builder.addCase(AccountProfilePostDelete.fulfilled, (state, action) => {
            state.loading = false;
            state.User_posts = state.User_posts.filter(post => post.id !== action.meta.arg);
            state.posts_count = state.posts_count > 0 ? state.posts_count - 1 : 0;
        });
        builder.addCase(AccountProfilePostDelete.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // account page followers list action promise
        builder.addCase(UserAccountFollowerlist.pending, (state, action) => {
            if (action.meta.arg?.isLoadMore) {
                state.loadingMoreMyConnections = true;
            } else {
                state.loading = true;
                state.User_followersList = [];
            }
        });
        builder.addCase(UserAccountFollowerlist.fulfilled, (state, action) => {
            const { data, isLoadMore } = action.payload;
            const list = data.followers || [];
            if (isLoadMore) {
                state.loadingMoreMyConnections = false;
                state.User_followersList = [...state.User_followersList, ...list];
            } else {
                state.loading = false;
                state.User_followersList = list;
            }
            state.myFollowersHasMore = !!data.has_next;
            state.followers_count = data.followers_count ?? state.followers_count;
        });
        builder.addCase(UserAccountFollowerlist.rejected, (state) => {
            state.loading = false;
            state.loadingMoreMyConnections = false;
        });

        // account page following list action promise
        builder.addCase(UserAccountFollowinglist.pending, (state, action) => {
            if (action.meta.arg?.isLoadMore) {
                state.loadingMoreMyConnections = true;
            } else {
                state.loading = true;
                state.User_followingList = [];
            }
        });
        builder.addCase(UserAccountFollowinglist.fulfilled, (state, action) => {
            const { data, isLoadMore } = action.payload;
            const list = data.following || [];
            if (isLoadMore) {
                state.loadingMoreMyConnections = false;
                state.User_followingList = [...state.User_followingList, ...list];
            } else {
                state.loading = false;
                state.User_followingList = list;
            }
            state.myFollowingHasMore = !!data.has_next;
            state.following_count = data.following_count ?? state.following_count;
        });
        builder.addCase(UserAccountFollowinglist.rejected, (state) => {
            state.loading = false;
            state.loadingMoreMyConnections = false;
        });

        // search within own followers list (prefix match)
        builder.addCase(searchMyFollowersList.pending, (state) => {
            state.searchingMyFollowers = true;
        });
        builder.addCase(searchMyFollowersList.fulfilled, (state, action) => {
            state.searchingMyFollowers = false;
            const results = action.payload?.searched_followers || [];
            state.mySearchedFollowersList = results.map(({ user, mutual_friends }) => {
                const existing = state.User_followersList.find((item) => item.follower_id === user?.id);
                return {
                    follower_id: user?.id,
                    follower_full_name: user?.full_name,
                    follower_avatar_url: user?.avatar_url || user?.avatar,
                    mutual_friends: mutual_friends || [],
                    is_following: existing ? existing.is_following : false,
                    is_follower: existing ? existing.is_follower : true,
                    requested: existing?.requested || false,
                };
            });
        });
        builder.addCase(searchMyFollowersList.rejected, (state, action) => {
            state.searchingMyFollowers = false;
            state.mySearchedFollowersList = [];
            state.error = action.payload;
        });

        // search within own following list (prefix match)
        builder.addCase(searchMyFollowingList.pending, (state) => {
            state.searchingMyFollowing = true;
        });
        builder.addCase(searchMyFollowingList.fulfilled, (state, action) => {
            state.searchingMyFollowing = false;
            const results = action.payload?.searched_following || [];
            state.mySearchedFollowingList = results.map(({ user, mutual_friends }) => {
                const existing = state.User_followingList.find((item) => item.following_id === user?.id);
                return {
                    following_id: user?.id,
                    following_full_name: user?.full_name,
                    following_avatar_url: user?.avatar_url || user?.avatar,
                    mutual_friends: mutual_friends || [],
                    is_following: existing ? existing.is_following : true,
                    is_follower: existing ? existing.is_follower : false,
                };
            });
        });
        builder.addCase(searchMyFollowingList.rejected, (state, action) => {
            state.searchingMyFollowing = false;
            state.mySearchedFollowingList = [];
            state.error = action.payload;
        });

        // // account page UserAccountFollow action promise
        // builder.addCase(UserAccountFollow.pending, (state) => {
        //     state.loading = true;
        // });
        // builder.addCase(UserAccountFollow.fulfilled, (state, action) => {
        //     // state.loading = false;
        // });
        // builder.addCase(UserAccountFollow.rejected, (state, action) => {
        //     // state.loading = false;
        //     state.error = action.payload;
        // });

        // account page OtherUserProfile action promise
        builder.addCase(OtherUserProfile.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(OtherUserProfile.fulfilled, (state, action) => {
            state.loading = false;
            state.otherUser_profile = action.payload;
            // state.otherUser_posts_count = action.payload.post_count || 0;
        });
        builder.addCase(OtherUserProfile.rejected, (state, action) => {
            state.loading = false;
            state.otherUser_profile = action.payload;
            state.error = action.payload;
        });

        // other user followers list action promise
        builder.addCase(otherUserFollowersList.pending, (state, action) => {
            if (action.meta.arg?.isLoadMore) {
                state.loadingMoreConnections = true;
            } else {
                state.loading = true;
                state.User_followersList = [];
            }
        });
        builder.addCase(otherUserFollowersList.fulfilled, (state, action) => {
            const { data, isLoadMore } = action.payload;
            const list = data.followers || [];
            if (isLoadMore) {
                state.loadingMoreConnections = false;
                state.User_followersList = [...state.User_followersList, ...list];
            } else {
                state.loading = false;
                state.User_followersList = list;
            }
            state.otherFollowersHasMore = !!data.has_next;
        });
        builder.addCase(otherUserFollowersList.rejected, (state, action) => {
            state.loading = false;
            state.loadingMoreConnections = false;
            state.error = action.payload;
        });

        // other user following list action promise
        builder.addCase(otherUserFollowingList.pending, (state, action) => {
            if (action.meta.arg?.isLoadMore) {
                state.loadingMoreConnections = true;
            } else {
                state.loading = true;
                state.User_followingList = [];
            }
        });
        builder.addCase(otherUserFollowingList.fulfilled, (state, action) => {
            const { data, isLoadMore } = action.payload;
            const list = data.following || [];
            if (isLoadMore) {
                state.loadingMoreConnections = false;
                state.User_followingList = [...state.User_followingList, ...list];
            } else {
                state.loading = false;
                state.User_followingList = list;
            }
            state.otherFollowingHasMore = !!data.has_next;
        });
        builder.addCase(otherUserFollowingList.rejected, (state, action) => {
            state.loading = false;
            state.loadingMoreConnections = false;
            state.error = action.payload;
        });

        // search within another user's followers list (substring match)
        builder.addCase(searchOtherUserFollowersList.pending, (state) => {
            state.searchingOtherFollowers = true;
        });
        builder.addCase(searchOtherUserFollowersList.fulfilled, (state, action) => {
            state.searchingOtherFollowers = false;
            state.otherSearchedFollowersList = action.payload?.searched_followers || [];
        });
        builder.addCase(searchOtherUserFollowersList.rejected, (state, action) => {
            state.searchingOtherFollowers = false;
            state.otherSearchedFollowersList = [];
            state.error = action.payload;
        });

        // search within another user's following list (substring match) — response is a bare array
        builder.addCase(searchotherUserFollowingList.pending, (state) => {
            state.searchingOtherFollowing = true;
        });
        builder.addCase(searchotherUserFollowingList.fulfilled, (state, action) => {
            state.searchingOtherFollowing = false;
            state.otherSearchedFollowingList = Array.isArray(action.payload) ? action.payload : [];
        });
        builder.addCase(searchotherUserFollowingList.rejected, (state, action) => {
            state.searchingOtherFollowing = false;
            state.otherSearchedFollowingList = [];
            state.error = action.payload;
        });

        // account page getPrivateVideos action promise
        builder.addCase(getPrivateVideos.pending, (state, action) => {
            if (action.meta.arg?.isLoadMore) {
                state.privateVideosLoadingMore = true;
            } else {
                state.loading = true;
            }
        });
        builder.addCase(getPrivateVideos.fulfilled, (state, action) => {
            const { data, isLoadMore } = action.payload;
            const posts = data.posts || data.results?.posts || [];
            if (isLoadMore) {
                state.privateVideosLoadingMore = false;
                state.private_Videos = [...state.private_Videos, ...posts];
            } else {
                state.loading = false;
                state.private_Videos = posts;
            }
            state.privateVideosNextPage = data.next ?? null;
            state.privateVideosHasMore = !!data.next;
        });
        builder.addCase(getPrivateVideos.rejected, (state, action) => {
            if (action.meta.arg?.isLoadMore) {
                state.privateVideosLoadingMore = false;
            } else {
                state.loading = false;
            }
            state.error = action.payload;
        });

        // account user Bloack User action promise
        builder.addCase(accountBlockUser.pending, (state) => {
            // state.loading = true;
        }
        );
        builder.addCase(accountBlockUser.fulfilled, (state, action) => {
            state.loading = false;
            state.otherUser_profile = {
                ...state.otherUser_profile,
                is_blocked: true,
            };

        });
        builder.addCase(accountBlockUser.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });


        builder.addCase(accountUnBlockUser.pending, (state) => {
            // state.loading = true;
        });
        builder.addCase(accountUnBlockUser.fulfilled, (state, action) => {
            state.loading = false;
            state.otherUser_profile = {
                ...state.otherUser_profile,
                is_blocked: false,
            };
        });
        builder.addCase(accountUnBlockUser.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export const { followUpdate, postCreatedUpdateState, updatePostLikeStatus, resetLoadingMore, clearAccountProfile, removePostFromList, removePrivateVideoFromList } = AccountProfileSlice.actions;
export default AccountProfileSlice.reducer;
